export default __webpack_public_path__ + "static/media/01.1b24be41.jpg";